import React from 'react';
import Transcription from './Transcription';
//import '../../css/scTable.css';
//import  '../../css/tabulka_SC_layout.css'
import '../../css/tabulky.css';

class SCResultTable extends React.Component {

    render() {

        let protocol = this.props.protocol.map((athlet, key) => (
            <tr key={key}>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{isNaN(athlet.poradi) ? athlet.poradi : athlet.poradi + '.'}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.bib}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.jmeno}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.zkrkat}</td>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </tr>
        ));

        let hiddenRow =
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </tr>;
        let row =
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </tr>;
        let oneRow = <>
            {protocol}
            {row}
        </>
        let twoRows = <>
            {protocol}
            {row}
            {row}
        </>;
        let threeRows = <>
            {row}
            {row}
            {row}
        </>;

        return (
            <div className="body2">
                <div className="card">
                    <div className="cardContent">
                        <table id="druha">

                            <tbody>
                            {hiddenRow}
                            {/*<tr>*/}
                            {/*    <th>&nbsp;</th>*/}
                            {/*    <th>&nbsp;</th>*/}
                            {/*    <th>&nbsp;</th>*/}
                            {/*    <th>&nbsp;</th>*/}
                            {/*    <th>&nbsp;</th>*/}
                            {/*    <th>&nbsp;</th>*/}
                            {/*</tr>*/}
                            <tr>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Poř.</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Stč.</th>
                                <th style={{
                                    backgroundColor: '#052d93',
                                    color: '#fff',
                                    fontWeight: '700'
                                }}>Jméno
                                </th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Čas</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>TJ</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Kat.</th>
                            </tr>
                            <tr>
                                <th style={{backgroundColor: '#0096ff', color: '#fff'}} colSpan="6">
                                    Události v cíli
                                </th>
                            </tr>

                            {this.props.protocol.length === 0 ? threeRows : this.props.protocol.length === 1 ? twoRows :
                                this.props.protocol.length === 2 ? oneRow : protocol}

                            <tr>
                                {this.props.stat !== undefined ?
                                    <th style={{backgroundColor: '#0096ff', color: '#fff'}}
                                        colSpan="6">DNS: {this.props.stat[0]} - Na startu: {this.props.stat[1]} - Na
                                        trati: {this.props.stat[2]} - V cíli: {this.props.stat[3]} -
                                        DSQ: {this.props.stat[4]} - DNF: {this.props.stat[5]}</th>
                                    : <th colSpan="6">&nbsp;</th>}
                            </tr>

                            <tr>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Poř.</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Stč.</th>
                                <th style={{
                                    backgroundColor: '#052d93',
                                    color: '#fff',
                                    fontWeight: '700'
                                }}>Jméno
                                </th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Čas</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>TJ</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Kat.</th>
                            </tr>

                            {this.props.athletes.map((athlet, key) => (
                                <tr key={athlet.id}>
                                    <td style={{backgroundColor: this.props.raceInfo.stc === athlet.stc ? '#0096ff' : key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.poradi}.</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.bib}</td>
                                    <td style={{
                                        backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa',
                                        align: "left"
                                    }}>{athlet.jmeno}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</td>
                                    <td style={{
                                        backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa',
                                        align: "left"
                                    }}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</td>
                                    <td style={{
                                        backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa',
                                        align: "left"
                                    }}>{athlet.zkrkat}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default SCResultTable;